import { createAction } from '@reduxjs/toolkit';
import { Service } from 'app/service/navigation/pages/page-types';
import { CustomerType, SelectCustomerLocation } from 'app/store/types/user-context-types';

// Action Creators
export const fetchUserContextStarted = createAction<undefined>('FETCH_USER_CONTEXT_STARTED');
export const fetchUserContextFulfilled = createAction<MinesiderBackend.UserContext>('FETCH_USER_CONTEXT_FULFILLED');
export const refreshUserContextStarted = createAction<undefined>('REFRESH_USER_CONTEXT_STARTED');
export const refreshUserContextFulfilled = createAction<MinesiderBackend.UserContext>('REFRESH_USER_CONTEXT_FULFILLED');
export const fetchUserContextFailed = createAction<undefined>('FETCH_USER_CONTEXT_FAILED');
export const changeCustomerLocation = createAction<undefined>('CHANGE_CUSTOMER_LOCATION');
export const selectCustomerLocation = createAction<SelectCustomerLocation>('SELECT_LOCATION');
export const selectCustomerSegment = createAction<CustomerType>('SELECT_SEGMENT');
export const updateCustomerLocationServices = createAction<Service[]>('UPDATE_LOCATION_SERVICES');
